import messages from './messages';

const TITLE_REGEX = new RegExp('Title');
const ANSWER_REGEX = 'A';
const QUESTION_REGEX = 'Q';
const SECTION_KEY = 'section';
const FAQ_ID = 'app.components.Faq';

const buildConst = (regex: string) => {
  return Object.keys(messages)
    .filter((k) => k.indexOf(SECTION_KEY) === 0)
    .filter((m) => m.match(regex))
    .map((v, k) => {
      return { id: k + 1, value: v };
    });
};

const QUESTIONS = buildConst(QUESTION_REGEX);
const ANSWERS = buildConst(ANSWER_REGEX);

export const FAQ_SECTIONS = Object.keys(messages)
  .filter((k) => k.indexOf(SECTION_KEY) === 0)
  .filter((m) => m.match(TITLE_REGEX))
  .map((value, k) => {
    return { id: k + 1, value: { id: `${FAQ_ID}.${value}` } };
  });

export const FAQ_QUESTIONS_ANSWERS = QUESTIONS.map((q) => {
  return {
    id: q.id,
    sectionId: +q.value.split(QUESTION_REGEX)[0].substring(SECTION_KEY.length),
    question: { id: `${FAQ_ID}.${q.value}` },
    answer: { id: `${FAQ_ID}.${ANSWERS.find((a) => a.id === q.id)!.value}` }
  };
});
